<!-- TEMPLATE -->
<template>
  <div :class="deanButtonClass">
    <button :class="deanButtonLinkClass" :disabled="disabled" @click="deanButtonClick()" :tabindex="tabindex">
      <slot></slot>
    </button>
  </div>
</template>

<!-- SCRIPT -->
<script lang="ts">
// VUE
import Vue from 'vue'
import { Component, Prop, } from 'vue-property-decorator'

// COMPONENTS
@Component({ })

export default class deanButton extends Vue {

  //PROPS
  @Prop() disabled!: boolean;
  @Prop() theme!:  string;
  @Prop({ default: false }) standard!: boolean;
  @Prop({ default: false }) success!:  boolean;
  @Prop({ default: false }) info!: boolean;
  @Prop({ default: false }) warning!:  boolean;
  @Prop({ default: false }) danger!: boolean;
  @Prop({ default: false }) primary!: boolean;
  @Prop({ default: false }) secondary!:  boolean;
  @Prop({ default: false }) grey!:  boolean;
  @Prop({ default: false }) groupButton!:  boolean;
  @Prop({ default: false }) dialogButton!: boolean;
  @Prop({ default: false }) fullWidth!: boolean;
  @Prop() tabindex!: Number;

  // DATA
  click: boolean = false;

  // COMPUTED
  get deanButtonClass() {
    let value = 'dean-button'
    if (this.groupButton) value += ` dean-button-group-item`
    else if (this.dialogButton)  value += ` dean-button-group-item dean-button-dialog`
    else if (this.fullWidth) value += ` dean-button-full-width`
    return value
  }

  get deanButtonLinkClass() {
    let value = 'dean-button-item'
    if (this.standard) value += ` dean-button-theme-standard`
    else if (this.success) value += ` dean-button-theme-success`
    else if (this.info) value += ` dean-button-theme-info`
    else if (this.warning) value += ` dean-button-theme-warning`
    else if (this.danger) value += ` dean-button-theme-danger`
    else if (this.primary) value += ` dean-button-theme-primary`
    else if (this.secondary) value += ` dean-button-theme-secondary`
    else if (this.grey) value += ` dean-button-theme-grey`
    else  value += ` dean-button-theme-standard`
    if (this.theme) {
      value += ` dean-button-theme-${this.theme}`
    }
    return value
  }
  // METHODS
  deanButtonClick() {
    this.click =! this.click;
    this.$emit('dean-button-click', this.click);
    this.click =! this.click;
  }
}
</script>

<!-- STYLE -->
<style lang="scss" scoped>

// IMPORT
@import '~@deanone/dean-components/src/scss/vars';

// DEAN BUTTON
.dean-button {
    display: inline-block;

    .dean-button-item {
      cursor: pointer;
      text-decoration: none;
      font-weight: 500;
      //text-transform: lowercase;
      margin: 0;
      border: 0;
      padding: 11px 30px 11px 30px;
      @include transition(all ease 1s);
      @include border-radius(100px);
      &:after {
        margin-left: 5px;
        content: " \203A";
      }
    }

    // STANDARD
    .dean-button-theme-standard {
      background: var(--color-light-shade-2, $color-light-shade-2);
      color: var(--color-dark-shade-2, $color-dark-shade-2);
      &:hover {
        color: var(--color-dark-shade-2, $color-dark-shade-2);
        background:var(--color-light, $color-light);
      }
    }

    // SUCCESS
    .dean-button-theme-success {
      background: var(--color-light-shade-2, $color-light-shade-2);
      color: var(--color-info-success, $color-info-success);
      &:hover {
        color: var(--color-info-success, $color-info-success);
        background: var(--color-info-success-bg, $color-info-success-bg);
      }
    }

    // INFO
    .dean-button-theme-info {
      background: var(--color-light-shade-2, $color-light-shade-2);
      color: var(--color-info-standard, $color-info-standard);
      &:hover {
        color: var(--color-info-standard, $color-info-standard);
        background: var(--color-info-standard-bg, $color-info-standard-bg);
      }
    }

    // WARNING
    .dean-button-theme-warning {
      background: var(--color-light-shade-2, $color-light-shade-2);
      color: var(--color-info-warning, $color-info-warning);
      &:focus,
      &:hover {
        color: var(--color-info-warning, $color-info-warning);
        background: var(--color-info-warning-bg, $color-info-warning-bg);
      }
    }

    // DANGER
    .dean-button-theme-danger {
      background: var(--color-light-shade-2, $color-light-shade-2);
      color: var(--color-info-danger, $color-info-danger);
      &:hover {
        color: var(--color-info-danger, $color-info-danger);
        background: var(--color-info-danger-bg, $color-info-danger-bg);
      }
    }

    // PRIMARY
    .dean-button-theme-primary {

      background: var(--color-primary, $color-primary);
      color: white;
      &:hover {
        color: white;
        background: var(--color-primary-shade-2, $color-primary-shade-2);
      }
    }

    // SECONDARY
    .dean-button-theme-secondary {
      background: var(--color-secondary, $color-secondary);
      color: white;
      &:hover {
        color: white;
        background: var(--color-secondary-shade-2, $color-secondary-shade-2);
      }
    }

    // LINK
    .dean-button-theme-link {
      background: var(--color-link, $color-link);
      color: white;
      &:hover {
        color: white;
        background: var(--color-link-shade-2, $color-link-shade-2);
      }
    }

      // GREY
    .dean-button-theme-grey {
      background: var(--color-light, $color-light);
      color: black;
      &:hover {
        color: black;
        background: var(--color-dark-shade-4, $color-dark-shade-4);
      }
    }
}

// BUTTON GROUP
.dean-button-group-item {
    padding: 0px;
    &:first-of-type { border-right: 1px solid var(--color-light, $color-light); }
    &:nth-of-type(n) { border-right: 1px solid var(--color-light, $color-light); }
    &:last-of-type { border-right: 0; }
    .dean-button-item {
      @include border-radius(0px);
      border: 0;
       &:after {
        margin-left: 0px;
        content: "";
      }
    }
}

// FULL WIDTH
.dean-button-full-width {
  display: block;
  min-width: 100%;
  .dean-button-item {
    min-width: 100%;
  }
}

// DIALOG BUTTONS
.dean-button-dialog {
    -webkit-flex: 1; /* Safari 6.1+ */
    -ms-flex: 1; /* IE 10 */
    flex: 1;
    margin: 0;
    text-align: center;

    &:first-of-type { border-right: 1px solid var(--color-light-shade-2, $color-light-shade-2); }
    &:nth-of-type(n) { border-right: 1px solid var(--color-light-shade-2, $color-light-shade-2); }
    &:last-of-type { border-right: 0; }

    .dean-button-item {
      min-width: 100%;
      min-height: 100%;
      text-align: center;
      padding: 20px;
       &:after {
        margin-left: 5px;
        content: none;
      }
    }

    // DIALOG STANDARD
    .dean-button-theme-standard {
      background: white;
      color: var(--color-dark-shade-2, $color-dark-shade-2);
    }

    // DIALOG SUCCESS
    .dean-button-theme-success {
      background: white;
      color: var(--color-info-success, $color-info-success);
    }

    // DIALOG INFO
    .dean-button-theme-info {
      background: white;
      color: var(--color-info-standard, $color-info-standard);
    }

    // DIALOG WARNING
    .dean-button-theme-warning {
      background: white;
      color: var(--color-info-warning, $color-info-warning);
    }

    // DIALOG DANGER
    .dean-button-theme-danger {
      background: white;
      color: var(--color-info-danger, $color-info-danger);
    }

    // DIALOG PRIMARY
    .dean-button-theme-primary {
      background: white;
      color: var(--color-primary, $color-primary);
    }

    // DIALOG SECONDARY
    .dean-button-theme-secondary {
      background: white;
      color: var(--color-secondary, $color-secondary);
    }

    // GREY
    .dean-button-theme-grey{
      background: white;
      color: var(--color-dark-shade-4, $color-dark-shade-4);
    }
}
</style>
